import BucketHeader from '../../../DTO/BucketHeader'
import {BucketMemberId} from '../../../DTO/BucketMemberId'
import React from 'react'
import {Line} from '../../Atoms/Line'

type BucketMemberIdContentProps = {
  bucketHeader: BucketHeader
  bucketMemberIdList: BucketMemberId[]
}
export const BucketMemberIdContent: React.VFC<BucketMemberIdContentProps> = (
  {
    bucketHeader,
    bucketMemberIdList,
  },
) => {
  const bucketMemberId = bucketMemberIdList.find(
    bucketMemberId => bucketMemberId.bucketId === bucketHeader.id)

  return !bucketMemberId || !bucketMemberId.bucketMemberId
    ? <></>
    : (
      <Line data-test-id={`bucket-member-id${bucketMemberId.bucketId}`}>
        会員番号：{bucketMemberId.bucketMemberId}
      </Line>
    )
}
